// @flow

import type { ObservableArray } from 'rgs-knockout';
import { withProps } from 'rgs-nfd-ui-kit/ko-components/helpers';
// tree
import BaseViewModel from 'rgs-nfd-ui-kit/ko-components/tree/BaseViewModel';
import TreeDataModel from 'rgs-nfd-ui-kit/ko-components/tree/tree-data-model';
import type { TChildNodes } from 'rgs-nfd-ui-kit/ko-components/tree/BaseViewModel';
import type { TTreeListOptions } from 'rgs-nfd-ui-kit/ko-components/tree-list/tree-list';
import TreeNodeModel from 'rgs-nfd-ui-kit/ko-components/tree/tree-node-model';

export type TTreePropsActions = {
	[string]: () => void
}

export type TTreeProps = {
	treeData: TreeDataModel;
	actions?: TTreePropsActions;
}

export type TTreeOptions = {
	props: TTreeProps
}

// viewModel
export class Tree extends BaseViewModel {
	treeData: TreeDataModel;
	tree: ObservableArray<TreeNodeModel>;
	props: {
		tree: ObservableArray<TreeNodeModel>,
	};
	emptyTemplate: TChildNodes;
	rowTemplate: TChildNodes;
	actions: TTreePropsActions;

	constructor (options: TTreeOptions, elementContent: any) {
		super(options, elementContent);

		if (options) {
			const {
				actions,
				treeData,
				...rest
			} = withProps(options);

			this.actions = actions;
			this.treeData = treeData;

			this.emptyTemplate = this.getChildNodes('empty-template');
			this.rowTemplate = this.getChildNodes('row-template');

			const listOptions: TTreeListOptions = {
				treeData: this.treeData.tree,
				rowTemplate: this.rowTemplate,
				$tree: this,
				// hasChildren: this.treeData.hasChildren,
				isRoot: true,
			};

			this.props = {
				treeData,
				listOptions,
				rowTemplate: this.rowTemplate,
				emptyTemplate: this.emptyTemplate,
				...rest,
			};
		}
	}
}
